import { useTeamSettings } from '../useTeamSettings'
import { SimpleModal, Box } from '@sequencehq/core-components'
import { Member } from '@stytch/react/b2b'
import { ReactElement } from 'react'

export const DeleteMemberModal = ({
  member,
  trigger
}: {
  member: Member
  trigger: ReactElement
}) => {
  const { deleteMember } = useTeamSettings()

  return (
    <SimpleModal
      variant="dialog"
      data-testid="team.deleteMember.dialog"
      trigger={trigger}
      title="Delete user"
      submitButtonText="Delete"
      submittingButtonText="Deleting"
      isDestructive
      disableSubmitOnEnter
      onSubmit={async () => {
        await deleteMember(member)
        return true
      }}
    >
      Are you sure? This will remove <b>{member.email_address}</b> from your
      workspace.
    </SimpleModal>
  )
}
